import { Stack } from "@mui/material";
import { Suspense, useState } from "react";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

export default function VerificationLayout({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <Stack
        flexGrow={1}
        minHeight="calc(100vh)"
        pl={{
          xs: 0,
          lg: 40.25, // 320px Sidebar Width
        }}
        pr={{
          xs: 0,
          lg: 0.25, // 320px Sidebar Width
        }}
        pb={{
          xs: 8, // 64px Footer Height
          sm: 0,
        }}
      >
        <Suspense>
          <Navbar onOpenSidebar={() => setOpen(true)} />
          {children}
        </Suspense>
      </Stack>
    </>
  );
}
